// extracted by mini-css-extract-plugin
export var Interface_SemiBold_XL = "typography-module--Interface_SemiBold_XL--876a5";
export var Neutral_8 = "#0C0C0C";
export var colors = "\"@theme/colors.module.css\"";
export var styles_emptyResultsTitle = "JobCardList-module--styles_emptyResultsTitle--8f6b3 typography-module--typeface_base--8d193 typography-module--Interface_SemiBold_XL--876a5";
export var typeface_base = "typography-module--typeface_base--8d193";
export var typography = "'@theme/typography.module.css'";